import React from 'react';
import Icon from '../icon/Icon';

import './Search.scss';

interface Props {
  id: string;
  name: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  placeholder?: string;
  isDisabled?: boolean;
  onReset?: () => void;
}

const Search: React.FC<Props> = ({ id, name, onChange, value, placeholder, isDisabled, onReset }) => {
  const isReset = value.length > 2;

  const onResetClick = () => {
    if (onReset && isReset) {
      onReset();
    }
  };

  return (
    <div className="search">
      <input className="search__input" value={value} id={id} name={name} onChange={onChange} placeholder={placeholder} disabled={isDisabled} />
      <Icon svg className="search__icon" icon="search" />
      {isReset && <Icon onClick={onResetClick} isButton={isReset} svg className="search__delete-icon" icon="x" />}
    </div>
  );
};

export default Search;
